module.exports = __webpack_public_path__ + "images/emails/statistics/pale-sky-919e9fcb9d72bce7be9c8f4522e8c32b.png";